export default __webpack_public_path__ + "static/media/element_69.06ed9397.avif";